<template>
    <div>
        <div class="carrello-container">
            <div class="carrello-row-1 container">
                <h1 class="h2-like-text d-flex">
                    {{ $root.translateString("your_cart") }}
                    <span class="count-numbers-style" v-if="itemCount > 0">({{ itemCount }})</span>
                </h1>

                <div class="carrello-row-1__btn d-767-none" v-if="isNotEmpty(cart)">
                    <div class="brand-btn mb-0">
                        <a class="full" :href="$root.langRoute('/cassa')">
                            <span>{{ $root.translateString("complete_checkout") }}</span>
                        </a>
                    </div>
                </div>
            </div>

            <div class="carrello-row-2" v-if="isNotEmpty(cart)">
                <div class="carrello-item" v-for="(item, key) in cart" :key="key">
                    <div class="container">
                        <div class="carrello-item__col-1">
                            <div class="carrello-item__image">
                                <img :alt="item.options.name" :src="item.options.image" />
                            </div>

                            <div class="carrello-item__content">
                                <h5 class="carrello-item__title pr-3 pr-sm-0" v-html="item.name.split('-')[0].replace('<br>', ' ')"></h5>
                                <div v-if="item.options.combination.indexOf('-') > -1 && item.options.type == 'vini'" class="carrello-item__year" v-text="item.options.combination.split('-')[1]"></div>
                                <div class="carrello-item__info">
                                    <div class="carrello-item__info-item" v-if="item.options.type == 'vini'">
                                        <span v-text="lang == 'it' ? 'Formato:' : 'Size:'"></span>
                                        <span v-if="item.options.combination.indexOf('-') > -1" v-text="item.options.combination.split('-')[0]"></span>
                                        <span v-else v-text="item.options.combination"></span>
                                    </div>
                                    <div class="carrello-item__info-item" v-else-if="item.options.type == 'visite' || item.options.type == 'eventi'">
                                        <span>
                                            <span class="mr-0">{{ parseInt(item.options.visit.adults) + parseInt(item.options.visit.kids) }}</span>
                                            <span class="text-grey" v-if="item.options.visit.adults == 1">{{ $root.translateString("person") }}</span>
                                            <span class="text-grey" v-else>{{ $root.translateString("people") }}</span>
                                            <span class="text-grey" v-if="item.options.combination && item.options.type != 'eventi'">
                                                -
                                                {{ translateVisitOptional(item.options.combination.replace(" ", "")) }}
                                            </span>
                                        </span>
                                        <span></span>
                                    </div>
                                    <div class="carrello-item__info-item" v-else-if="item.options.type == 'gift-card'">
                                        <span v-if="lang == 'it'" class="text-grey">
                                            Valore:
                                            <span class="text-dark pl-1">{{ $root.currencyDisplaySimple(item.options.price) }}€</span>
                                        </span>
                                        <span class="text-grey" v-else>
                                            <span class="text-dark">{{ $root.currencyDisplaySimple(item.options.price) }}€</span>
                                            Value
                                        </span>
                                    </div>
                                    <div class="carrello-item__info-item" v-else>
                                        <span>Cantina Roeno</span>
                                        <span></span>
                                    </div>
                                </div>
                                <div class="carrello-item__quantity-price d-768-none d-flex flex-column align-items-start flex-sm-row">
                                    <div class="carrello-item__quantity" v-if="item.options.type != 'visite' || item.options.type == 'eventi'">
                                        <div class="quantity-btns">
                                            <div class="quantity-btns__minus">
                                                <img src="/images/svg/roeno-04.svg" alt="icona" />
                                            </div>

                                            <div class="quantity-btns__input">
                                                <input type="number" min="1" v-model="item.qty" />
                                            </div>

                                            <div class="quantity-btns__plus">
                                                <img src="/images/svg/roeno-05.svg" alt="icona" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carrello-item__price ml-0 ml-sm-3 mt-2 pt-1 mt-sm-0 pt-sm-0">
                                        <div class="price-style">
                                            <span>€</span>
                                            <span>{{ $root.currencyDisplaySimple(parseFloat(item.price) * parseInt(item.qty)) }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="carrello-item__col-2">
                            <div class="carrello-item__remove-btn">
                                <a href="javascript:void(0)" @click="updateCart(key, 0)">
                                    <img src="/images/svg/as-1.svg" alt="icona" />
                                    <span>{{ $root.translateString("remove") }}</span>
                                </a>
                            </div>

                            <div class="carrello-item__quantity-price d-767-none">
                                <div class="carrello-item__quantity" v-if="item.options.type != 'visite' || item.options.type == 'eventi'">
                                    <div class="quantity-btns">
                                        <div class="quantity-btns__minus" @click="decreaseQuantity(key, item)">
                                            <img src="/images/svg/roeno-04.svg" alt="icona" />
                                        </div>

                                        <div class="quantity-btns__input">
                                            <input readonly type="number" min="1" v-model="item.qty" />
                                        </div>

                                        <div class="quantity-btns__plus" @click="increaseQuantity(key, item)">
                                            <img src="/images/svg/roeno-05.svg" alt="icona" />
                                        </div>
                                    </div>
                                </div>
                                <div class="carrello-item__price">
                                    <div class="price-style">
                                        <span>€ </span>
                                        <span>{{ $root.currencyDisplaySimple(parseFloat(item.price) * parseInt(item.qty)) }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="carrello-row-3 container" v-if="isNotEmpty(cart)">
                <div class="carrello-row-3__left d-none d-md-block">
                    <div class="carrello-row-3__torna-btn">
                        <!--<img src="/images/svg/roeno-16.svg" alt="icona" />-->

                        <div class="brand-btn">
                            <a :href="'/' + lang + '/shop'">
                                <span>{{ $root.translateString("go_to_shop") }}</span>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="carrello-row-3__right">
                    <div class="carrello-row-3__subtotals-line">
                        <div class="carrello-row-3__subtotals-line-left">
                            {{ $root.translateString("subtotal") }}
                        </div>
                        <div class="carrello-row-3__subtotals-line-right">
                            {{ $root.currencyDisplaySimple(priceTotalWt) }}
                        </div>
                    </div>

                    <div class="carrello-row-3__subtotals-line" v-if="should_be_shipped">
                        <div class="carrello-row-3__subtotals-line-left">
                            {{ $root.translateString("shipping") }}
                        </div>
                        <div class="carrello-row-3__subtotals-line-right">
                            <span v-if="shipping > 0"> € {{ $root.currencyDisplaySimple(shipping) }} </span>
                            <span v-else>{{ $root.translateString("free") }}</span>
                        </div>
                    </div>

                    <div class="carrello-row-3__subtotals-line" v-if="discount > 0">
                        <div class="carrello-row-3__subtotals-line-left">
                            {{ $root.translateString("discount") }}
                        </div>
                        <div class="carrello-row-3__subtotals-line-right">€ - {{ $root.currencyDisplaySimple(discount) }}</div>
                    </div>

                    <div class="carrello-row-3__separator"></div>

                    <div class="carrello-row-3__totals-line">
                        <div class="carrello-row-3__totals-line-left">
                            <div class="t1">
                                {{ $root.translateString("total") }}
                            </div>
                            <div class="t2">
                                {{ $root.translateString("tax_included") }}
                            </div>
                        </div>
                        <div class="carrello-row-3__totals-line-right">
                            <div class="price-style">€ {{ $root.currencyDisplaySimple(finalPrice) }}</div>
                        </div>
                    </div>

                    <discount-box :lang="lang" :discount="discount"></discount-box>

                    <div class="carrello-row-3__procedi">
                        <div class="brand-btn w-100 text-nowrap">
                            <a class="full w-100 text-center" :href="$root.langRoute('/cassa')">
                                <span>{{ $root.translateString("complete_checkout") }}</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="carrello-row-3 container flex-column mb-5 pb-5" v-else>
                <p class="mb-5">{{ $root.translateString("empty_cart") }}</p>
                <div class="carrello-row-3__left d-none d-md-block">
                    <div class="carrello-row-3__torna-btn d-inline-flex">
                        <div class="brand-btn">
                            <a :href="'/' + lang + '/shop'">
                                <span>{{ $root.translateString("go_to_shop") }}</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: ["lang"],
        data() {
            return {
                show: false,
                cartRaw: null,
                count: 0,
                shipping: 0,
                discount: 0,
                finalPrice: 0,
                priceTotalWt: 0,
                missing_for_free_shipping: 0,
                should_be_shipped: false,
            };
        },
        mounted() {
            this.getCart();

            this.$eventHub.$on("cart.added", (payload) => {
                this.getCart();

                this.show = true;

                setTimeout(() => {
                    this.show = false;
                }, 5000);
            });

            this.$eventHub.$on("cart.show", (payload) => {
                this.show = true;
            });

            this.$eventHub.$on("discount.applied", (payload) => {
                this.getCart();
            });
        },
        methods: {
            translateVisitOptional(str) {
                if (this.lang == "en" && str.indexOf("tagliere") > -1) {
                    if (str.indexOf("pax") > -1) {
                        return str.split(" - ")[0] + " - cold cuts included";
                    } else {
                        return str.split(" - ")[0] + " - without cold cuts";
                    }
                }
                return str;
            },
            increaseQuantity(key, item) {
                if (item.qty < 30) {
                    item.qty++;
                } else {
                    item.qty = 30;
                }
                this.updateCart(key, item.qty);
            },
            decreaseQuantity(key, item) {
                if (item.qty > 1) {
                    item.qty--;
                } else {
                    item.qty = 1;
                }
                this.updateCart(key, item.qty);
            },
            goToCheckout(url) {
                let temp_cart = [];

                Object.keys(this.cart).forEach((o, k) => {
                    let entry = {};
                    entry.id = this.cart[o].options.name;
                    entry.quantity = this.cart[o].qty;
                    temp_cart.push(entry);
                });

                /*fbq('track', 'InitiateCheckout',
                {
                    value: parseFloat(this.priceTotalWt),
                    currency: 'EUR',
                    contents: temp_cart,
                    content_type: 'product_group'
                }
            );*/

                window.location.href = url;
            },
            emptyCart() {
                axios.post("/api/cart/empty", {}).then((response) => {
                    this.cartRaw = null;
                    this.shipping = 0;
                    this.priceTotalWt = 0;
                    this.finalPrice = 0;
                    this.discount = 0;
                    this.missing_for_free_shipping = 0;
                    this.should_be_shipped = false;
                });
            },
            updateCart(key, value) {
                axios
                    .post("/api/cart/update", {
                        key: key,
                        qty: value,
                    })
                    .then((response) => {
                        this.getCart();
                        this.$eventHub.$emit("cart.updated");
                        this.$eventHub.$emit("cart.updated.simpleQty", parseInt(response.data.count));

                        let update_type = "add";
                        let quantity_to_track = value;

                        let itemId = null;

                        if (typeof this.cart[key].options.gaId != "undefined") {
                            itemId = this.cart[key].options.gaId;
                        } else {
                            itemId = this.cart[key].id;
                        }

                        if (quantity_to_track == 0) {
                            quantity_to_track = this.cart[key].qty;

                            dataLayer.push({ ecommerce: null });
                            dataLayer.push({
                                event: "remove_from_cart",
                                ecommerce: {
                                    items: [
                                        {
                                            item_name: this.cart[key].options.name.replace("<br>", " "),
                                            item_id: itemId,
                                            price: this.$root.currencyDisplayGtm(this.cart[key].options.price),
                                            item_brand: "Cantina Roeno",
                                            item_category: this.cart[key].options.type,
                                            item_variant: this.cart[key].options.combination.toLowerCase(),
                                            quantity: quantity_to_track,
                                        },
                                    ],
                                },
                            });
                        } else {
                            dataLayer.push({ ecommerce: null });
                            dataLayer.push({
                                event: "add_to_cart",
                                ecommerce: {
                                    items: [
                                        {
                                            item_name: this.cart[key].options.name.replace("<br>", " "),
                                            item_id: itemId,
                                            price: this.$root.currencyDisplayGtm(this.cart[key].options.price),
                                            item_brand: "Cantina Roeno",
                                            item_category: this.cart[key].options.type,
                                            item_variant: this.cart[key].options.combination.toLowerCase(),
                                            quantity: quantity_to_track,
                                        },
                                    ],
                                },
                            });
                        }
                    });
            },
            getCart() {
                axios.get("/api/cart/get").then((response) => {
                    //console.log(response);
                    this.cartRaw = response.data.cart;
                    this.count = response.data.count;
                    this.priceTotalWt = response.data.priceTotalWt;
                    this.finalPrice = response.data.finalPrice;
                    this.shipping = response.data.shipping;
                    // this.missing_for_free_shipping = response.data.missingForFreeShipping;
                    this.discount = response.data.discount;
                    this.should_be_shipped = response.data.shouldBeShipped;

                    let products_gtm = [];

                    try {
                        Object.keys(this.cartRaw).forEach((key) => {
                            let entry = {};

                            if (typeof this.cartRaw[key].options.gaId != "undefined") {
                                entry.item_id = this.cartRaw[key].options.gaId;
                            } else {
                                entry.item_id = this.cartRaw[key].id;
                            }

                            entry.quantity = this.cartRaw[key].qty;
                            entry.item_brand = "Cantina Roeno";
                            entry.item_name = this.cartRaw[key].options.name.replace("<br>", " ");
                            entry.price = this.$root.currencyDisplayGtm(this.cartRaw[key].price);
                            entry.item_variant = this.cartRaw[key].options.combination.toLowerCase();
                            entry.item_category = this.cartRaw[key].options.type;
                            products_gtm.push(entry);
                        });

                        dataLayer.push({ ecommerce: null });
                        dataLayer.push({
                            event: "view_cart",
                            ecommerce: {
                                items: products_gtm,
                            },
                        });
                    } catch (e) {
                        console.log(e);
                    }
                });
            },
            isNotEmpty(object) {
                return _.isEmpty(object) === false;
            },
        },
        beforeDestroy() {
            this.$eventHub.$off("cart.added");
            this.$eventHub.$off("cart.show");
        },
        computed: {
            cart() {
                if (this.cartRaw == null) {
                    return null;
                }

                let tmp = {};
                for (const [key, value] of Object.entries(this.cartRaw)) {
                    if (typeof value.options.isDiscount == "undefined" || value.options.isDiscount == false) {
                        tmp[key] = value;
                    }
                }

                return tmp;
            },
            itemCount() {
                if (typeof this.cart == "undefined" || this.cart == null) {
                    return 0;
                } else {
                    return Object.keys(this.cart).length < 10 ? "0" + Object.keys(this.cart).length : Object.keys(this.cart).length;
                }
            },
        },
    };
</script>
